let content_blocks = ( function( $ ) {

	let $link_boxes;
	
	let _init = function() {
		$link_boxes = $( '.link-boxes.set-heights' );

		if ( $link_boxes.length > 0 ) {
			_setup_link_box_heights();

			$( window ).smartresize( function() {
				_setup_link_box_heights();
			} );
		}
	};

	let _setup_link_box_heights = function() {
		let $boxes = $link_boxes.find( '.link-box' ),
			height = 0;

		$boxes.each( function( index, item ) {
			if ( $( item ).outerHeight() > height ) {
				height = $( item ).outerHeight();
			}
		} );

		$boxes.css( 'height', height );
	};

	
	if ( $( '.link-boxes' ).length > 0 ) {
		$( document ).ready( _init );
	}
	
} )( jQuery );

module.exports = content_blocks;